<img *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code">
